"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compProps', 'compStylableClass', 'isMobileView'], function (_a, carmiData) {
    var compProps = _a.compProps, compStylableClass = _a.compStylableClass, isMobileView = _a.isMobileView;
    var separator = compProps.separator, direction = compProps.direction, shouldWrap = compProps.shouldWrap, showHomePage = compProps.showHomePage, showCurrentPage = compProps.showCurrentPage, showHomePageAsIcon = compProps.showHomePageAsIcon, showOnlyPreviousPageOnMobile = compProps.showOnlyPreviousPageOnMobile;
    return {
        breadcrumbs: [],
        currentPageHref: '',
        svgString: carmiData.svgString,
        separator: separator,
        direction: direction,
        shouldWrap: shouldWrap,
        showHomePage: showHomePage,
        showCurrentPage: showCurrentPage,
        showHomePageAsIcon: showHomePageAsIcon,
        showOnlyPreviousPageOnMobile: isMobileView && showOnlyPreviousPageOnMobile,
        // TODO - remove this hack once the EE side is refactored and pushed to bolt
        isMobile: true,
        className: compStylableClass,
    };
});
exports.css = withCompInfo_1.withCompInfo(['compProps'], function (_a) {
    var compProps = _a.compProps;
    var horizontalMargin = compProps.horizontalMargin, verticalMargin = compProps.verticalMargin, alignment = compProps.alignment;
    return {
        '--horizontalMargin': horizontalMargin + "px",
        '--verticalMargin': verticalMargin + "px",
        '--alignment': alignment,
    };
});
//# sourceMappingURL=Breadcrumbs.js.map